import { TaskContext } from "contexts/TaskDetailContext";
import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showError } from "../../redux/common/actions";
import { getModelTaskPermits } from "services/models/modelDetails/modelTaskPermits";
import { ModelContext } from "contexts/ModelDetailContext";

export default function useModelTaskPermits({ taskInfo, isMounted }) {
	const [originalPermits, setOriginalPermits] = useState([]);
	const [permits, setPermits] = useState([]);
	const [, CtxDispatch] = useContext(TaskContext);
	const [state, MtxDispatch] = useContext(ModelContext);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	const fetchPermits = async (showLoading = true) => {
		!isMounted.aborted && showLoading && setLoading(true);
		try {
			const response = await getModelTaskPermits(taskInfo.id);
			if (response.status) {
				if (!isMounted.aborted) {
					setPermits(response?.data);
					setOriginalPermits(response?.data);
				}
				CtxDispatch({
					type: "TAB_COUNT",
					payload: {
						countTab: "permitCount",
						data: response?.data?.length,
					},
				});
				if (response.data.length > 0) {
					CtxDispatch({
						type: "SET_PERMITS",
						payload: true,
					});
				} else {
					CtxDispatch({
						type: "SET_PERMITS",
						payload: false,
					});
				}
			} else {
				dispatch(
					showError(
						response?.data?.title ||
							response?.data ||
							"Could not fetch task permits"
					)
				);
			}
		} catch (error) {
			dispatch(
				showError(
					error?.response?.data ||
						error?.response ||
						"Could not fetch task permits"
				)
			);
		} finally {
			!isMounted.aborted && showLoading && setLoading(false);
		}
	};

	useEffect(() => {
		fetchPermits();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		CtxDispatch,
		MtxDispatch,
		fetchPermits,
		loading,
		originalPermits,
		permits,
		setLoading,
		setOriginalPermits,
		setPermits,
		state,
	};
}
